import { Encoder } from '@everyboard/lib';
export class QuartoPiece {
    value;
    static AAAA = new QuartoPiece(0);
    static AAAB = new QuartoPiece(1);
    static AABA = new QuartoPiece(2);
    static AABB = new QuartoPiece(3);
    static ABAA = new QuartoPiece(4);
    static ABAB = new QuartoPiece(5);
    static ABBA = new QuartoPiece(6);
    static ABBB = new QuartoPiece(7);
    static BAAA = new QuartoPiece(8);
    static BAAB = new QuartoPiece(9);
    static BABA = new QuartoPiece(10);
    static BABB = new QuartoPiece(11);
    static BBAA = new QuartoPiece(12);
    static BBAB = new QuartoPiece(13);
    static BBBA = new QuartoPiece(14);
    static BBBB = new QuartoPiece(15);
    static EMPTY = new QuartoPiece(16);
    static pieces = [
        QuartoPiece.AAAA,
        QuartoPiece.AAAB,
        QuartoPiece.AABA,
        QuartoPiece.AABB,
        QuartoPiece.ABAA,
        QuartoPiece.ABAB,
        QuartoPiece.ABBA,
        QuartoPiece.ABBB,
        QuartoPiece.BAAA,
        QuartoPiece.BAAB,
        QuartoPiece.BABA,
        QuartoPiece.BABB,
        QuartoPiece.BBAA,
        QuartoPiece.BBAB,
        QuartoPiece.BBBA,
        QuartoPiece.BBBB,
    ];
    static encoder = Encoder.fromFunctions((p) => p.value, QuartoPiece.ofInt);
    static ofInt(piece) {
        if (0 <= piece && piece <= 15) {
            return QuartoPiece.pieces[piece];
        }
        else if (piece === 16) {
            return QuartoPiece.EMPTY;
        }
        else {
            throw new Error('Invalid piece (' + piece + ')');
        }
    }
    constructor(value) {
        this.value = value;
    }
    equals(other) {
        return this === other;
    }
    toString() {
        return 'QuartoPiece(' + this.value + ')';
    }
    isRectangle() {
        return this.value % 4 < 2;
    }
}
